import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Container, Modal, Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { trackGaEvent } from '../lib/ga';

const CONTACT_URL =
  process.env.REACT_APP_SCALE2REV_CONTACT_URL || 'https://scale2rev.com/contact';
const COUNTDOWN_SECONDS = 5;

function buildContactUrl(search) {
  if (!search) return CONTACT_URL;
  return `${CONTACT_URL}${search.startsWith('?') ? search : `?${search}`}`;
}

function ContactRedirect() {
  const location = useLocation();
  const redirectUrl = useMemo(
    () => buildContactUrl(location.search),
    [location.search]
  );
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);
  const redirectedRef = useRef(false);

  const redirect = useCallback(() => {
    if (redirectedRef.current) return;
    redirectedRef.current = true;
    trackGaEvent('contact_redirect', { destination: 'scale2rev_contact', page_path: '/contact' });
    window.location.assign(redirectUrl);
  }, [redirectUrl]);

  useEffect(() => {
    document.title = 'Contact — Redirecting to Scale2Rev | TheSkinnyAI';
    trackGaEvent('contact_redirect_view', { page_path: '/contact' });
  }, []);

  useEffect(() => {
    if (secondsLeft <= 0) {
      redirect();
      return undefined;
    }
    const timer = window.setTimeout(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);
    return () => window.clearTimeout(timer);
  }, [secondsLeft, redirect]);

  return (
    <Container className="py-5">
      <Modal show centered backdrop="static" keyboard={false} data-bs-theme="light">
        <Modal.Header>
          <Modal.Title>Contact Scale2Rev</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            You will be redirected to Scale2Rev contact in{' '}
            <strong>{secondsLeft}</strong> {secondsLeft === 1 ? 'second' : 'seconds'}.
          </p>
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center justify-content-between gap-2">
          <Button variant="primary" onClick={redirect}>
            Continue now
          </Button>
          <a
            href="/login"
            className="text-muted text-center text-sm-end"
            style={{ fontSize: '0.875rem' }}
          >
            Existing customer? Log in to TheSkinnyAI
          </a>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default ContactRedirect;
